import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { NuevoViajeEADModelEdit } from "./nuevo";
import { ViajeEADFiltroComponent } from "./filtro";
import { IniciarEnDispositivo } from "../../viajeapp/logic";

import { CartaPortePorClienteModal } from "./modal";


type Entity = models.ViajeEADDto;
import { columnas } from "./columns";
const resource = resources.ViajeEAD;
interface State {
    filtro: models.FiltroViajeEAD;
}

interface Props {
    filtro: models.FiltroViajeEAD;
    HabilitarValidacionesCartaPorte : boolean;
}

const CrearButton = kea.defaultProps(kea.Button, { children: "Crear viaje", style: "info", iconClass: fa("plus") });

export class ViajeEADListNoRx extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = { filtro: {} };
    }

    filtro = (state: State) => state.filtro;
    items = createSelectorRx(this.filtro, filtro => observeResource(resource.ConsultarViajes, filtro));

    HabilitarValidacionesCartaPorte = observeResource(resources.ConfigSistema.HabilitarValidacionesCartaPorte);
    
    modalManager = kea.createModalManager();

    onDarLlegada = async (x: Entity) => {
        if(await kea.yesno(`¿Dar llegada al viaje con folio ${x.Folio}?`)) {
            await resource.MarcarFinalizadoPendienteDescarga(x.IdRegistro);
            await kea.message("Listo", "", "success");
        }
    }

    onDarSalida = async (x: Entity) => {
        if(await kea.yesno(`¿Dar salida al viaje con folio ${x.Folio}?`)) {
            await resource.DarSalidaViaje(x.IdRegistro);
            await kea.message("Listo", "", "success");
        }
    }

    onIniciarApp = async (x: Entity) => {
        if(await kea.yesno(`¿Iniciar viaje ${x.Folio} en este dispositivo?`)) {
            await IniciarEnDispositivo(x.IdRegistro);
            await kea.message("Viaje iniciado en dispositivo", "", "success");
        }
    }

    onCancelar = async (x: Entity) => {
        if(await kea.yesno(`¿Cancelar el viaje con folio ${x.Folio}?`)) {
            await resource.CancelarViaje(x.IdRegistro);
            await kea.message("Viaje cancelado", "", "success");
        }
    }

    onAgregar = async () => {
        const result = await this.modalManager.showModal(NuevoViajeEADModelEdit, undefined, {} as models.NuevoViajeEADModel);
        if (result.result) {
            await resource.CrearViaje(result.value);
            await kea.message("Viaje creado", "", "success");
        }
    }

    onTimbrarCartaPorteEAD = async (x: Entity) => {
        if (await kea.yesno(`¿timbrar carta por del viaje ${x.Folio} ?`)) {

            var xml = await resources.Factura.TimbrarCartaPorteEAD(x.IdRegistro);
            kea.download(kea.base64ToBlob(xml, 'application/xml'), "CartaPorteViajeEAD"+ x.Folio + ".xml");
            if  (!x.TieneXmlCartaPorteTimbrado)
            location.reload();
        }
    }

    onImprimirCartaPorteEAD = async (x: Entity) => {
        if (await kea.yesno(`¿Imprimir pdf de carta porte del viaje ${x.Folio} ?`)) {
            var PdfCartaPorte = await resources.Factura.ImprimirPdfEAD(x.IdRegistro);
            kea.download(kea.base64ToBlob(PdfCartaPorte, 'application/pdf'), "CartaPorteViajeEAD"+ x.Folio + ".pdf");
            
            if  (!x.TienexmlImpreso)
            location.reload();
        }
    }

    onMostrarListadoCartaPorteEAD = async (x: Entity) => {
        await this.modalManager.showModal(CartaPortePorClienteModal, undefined, x);
    }

    

    onVer = async ( x: Entity) => {
        history.go("./" + x.IdRegistro); 
    }
    
    onRegresar = () => history.go("../");

    render() {
        const items = this.items(this.state);

        const cols = columnas(this,this.props.HabilitarValidacionesCartaPorte);
        return (
            <div>
                <kea.Title titulo="Viajes de entrega a domicilio" onRegresar={this.onRegresar}>
                    <CrearButton onClick={this.onAgregar} />
                </kea.Title>

                <ViajeEADFiltroComponent value={this.state.filtro} onChange={filtro => this.setState({ filtro })} />
                <kea.Grid2 columnas={cols} cookieKey={"ViajeEADListCookieKey"} items={items} />
                {this.modalManager.component}
            </div>
        )
    }
}


const ViajeEADListRx = componentToRx(ViajeEADListNoRx);

export class ViajeEADList extends React.PureComponent {

    HabilitarValidacionesCartaPorte = observeResource(resources.ConfigSistema.HabilitarValidacionesCartaPorte);

    render() {
        return (
            <ViajeEADListRx  HabilitarValidacionesCartaPorte={ this.HabilitarValidacionesCartaPorte } />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/list/list.tsx